// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftSaveStatus_decode($$enum) {
  if ($$enum === "Saved" || $$enum === "SaveInProgress" || $$enum === "FirstSaveInProgress" || $$enum === "NotSaved" || $$enum === "SaveFailed") {
    return $$enum;
  }
  
}

function localDraftSaveStatus_fromString(str) {
  return localDraftSaveStatus_decode(str);
}

var Utils = {
  localDraftSaveStatus_decode: localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: localDraftSaveStatus_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelaySaveDraft_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftSaveStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
